export const iconFontAwesomeHouseholdSnowflake = (
	<i className="fa-solid fa-snowflake"></i>
);
